import { render, staticRenderFns } from "./ShutterOpening.vue?vue&type=template&id=2c57265b&scoped=true"
import script from "./ShutterOpening.vue?vue&type=script&lang=ts"
export * from "./ShutterOpening.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57265b",
  null
  
)

export default component.exports